import type { ProseSection } from "@/components/marketing/RichProse";

export const TREE_SETUP: ProseSection = {
  heading: "How we set up Google Ads for a tree service",
  paragraphs: [],
  points: [
    "01 Separate campaigns for removal, trimming and emergency storm work.",
    "02 A storm budget plan turns spend up within hours and back down when demand settles.",
    "03 The service radius follows where the crew can actually get to.",
    "04 Local Services Ads run beside Search.",
  ],
};